import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useHandymanAuth } from '../context/HandymanAuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { HardHat, ArrowLeft, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export const HandymanLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useHandymanAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Welcome back!');
      navigate('/handyman/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-12 bg-muted/50">
      <div className="w-full max-w-md animate-in">
        <Link to="/" className="flex items-center gap-2 text-muted-foreground hover:text-foreground mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4" />
          Back to home
        </Link>
        
        <Card className="border-border shadow-xl">
          <CardHeader className="text-center pb-2">
            <div className="w-14 h-14 rounded-2xl bg-primary flex items-center justify-center mx-auto mb-4">
              <HardHat className="w-7 h-7 text-primary-foreground" />
            </div>
            <CardTitle className="text-2xl font-['Outfit']">Handyman Portal</CardTitle>
            <CardDescription>Sign in to manage your enquiries</CardDescription>
          </CardHeader>
          <CardContent className="pt-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="h-12"
                  data-testid="handyman-login-email"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="password">Password</Label>
                <Input
                  id="password"
                  type="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="h-12"
                  data-testid="handyman-login-password"
                />
              </div>
              <Button 
                type="submit" 
                className="w-full h-12 rounded-xl" 
                disabled={loading}
                data-testid="handyman-login-submit"
              >
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Sign In'}
              </Button>
            </form>
            
            <div className="mt-6 text-center text-sm text-muted-foreground">
              Not registered yet?{' '}
              <Link to="/handyman/apply" className="text-primary font-medium hover:underline" data-testid="apply-link">
                Apply to join
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
